import React from "react"
import { Box, FormControlLabel, Switch, Typography } from "@material-ui/core"
import { ContactSubscriptionGroupItem as ItemType } from "@ua/web-sdk/lib/remote-data/preference-center"
import { ItemProps } from "./types"

const ContactSubscriptionItem: React.FC<ItemProps<ItemType>> = ({
  item,
  onSubscribe,
  onUnsubscribe,
  isSubscribed,
}) => {
  return (
    <>
      <Typography variant="body1">{item.display.name}</Typography>
      {item.display.description && (
        <Typography variant="caption">{item.display.description}</Typography>
      )}
      <Box>
        {item.components.map((component, idx) => (
          <React.Fragment key={idx}>
            {component.scopes.map((scope) => (
              <FormControlLabel
                key={`${idx}.${scope}`}
                control={
                  <Switch
                    data-qa-selector={`preference-center-subscription-${item.subscription_id}-checkbox`}
                    checked={isSubscribed(item.subscription_id, scope)}
                    onChange={(ev) => {
                      if (ev.target.checked) {
                        onSubscribe(item.subscription_id, scope)
                      } else {
                        onUnsubscribe(item.subscription_id, scope)
                      }
                    }}
                    name={item.subscription_id}
                    color="primary"
                  />
                }
                label={
                  <>
                    <Typography variant="body1">
                      {component.display.name}
                    </Typography>
                  </>
                }
              ></FormControlLabel>
            ))}
          </React.Fragment>
        ))}
      </Box>
    </>
  )
}

export default ContactSubscriptionItem
